import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import HostDashboard from "@/pages/HostDashboard";
import GuestDashboard from "@/pages/GuestDashboard";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import HostProfile from "@/pages/HostProfile";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Cancellation from "@/pages/Cancellation";
import ReconsentGate from "@/components/ReconsentGate";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-12 text-center text-neutral-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing/>} />
        <Route path="/browse" element={<Browse/>} />
        <Route path="/listings/:id" element={<ListingDetail/>} />
        <Route path="/hosts/:id" element={<HostProfile/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/signup" element={<Signup/>} />
        <Route path="/host" element={<Protected><HostDashboard/></Protected>} />
        <Route path="/trips" element={<Protected><GuestDashboard/></Protected>} />
        <Route path="/payment/success" element={<PaymentSuccess/>} />
        <Route path="/payment/cancel" element={<PaymentCancel/>} />
        <Route path="/terms" element={<Terms/>} />
        <Route path="/privacy" element={<Privacy/>} />
        <Route path="/cancellation" element={<Cancellation/>} />
        <Route path="*" element={<Navigate to="/" replace/>}/>
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes/>
        <ReconsentGate/>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}
